import { useEffect, useState } from "react";
import { History, Trash2, X } from "lucide-react";
import { listSessions, deleteSession } from "./assistApi";

export const AssistHistory = ({ t, onPick, onClose, current }) => {
  const [list, setList] = useState(null);
  const load = () => listSessions().then(setList).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const del = async (e, id) => { e.stopPropagation(); await deleteSession(id); load(); };
  return (
    <div className="absolute inset-0 z-10 bg-[#0a0d18] flex flex-col" data-testid="assist-history">
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
        <span className="flex items-center gap-2 text-sm text-white"><History className="w-4 h-4" />{t("as.history")}</span>
        <button onClick={onClose} data-testid="assist-history-close" className="p-1.5 text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>
      </div>
      <div className="flex-1 overflow-y-auto cx-scroll p-3 space-y-1.5">
        {list === null ? null : !list.length ? <p className="text-xs text-slate-500 p-3" data-testid="assist-history-empty">{t("as.no_history")}</p>
          : list.map((s) => (
            <div key={s.id} role="button" onClick={() => onPick(s.id)} data-testid={`assist-session-${s.id}`}
              className={`group flex items-center gap-2 rounded-lg px-3 py-2.5 cursor-pointer transition-colors ${current === s.id ? "bg-white/[0.07]" : "hover:bg-white/[0.04]"}`}>
              <div className="flex-1 min-w-0">
                <div className="text-[13px] text-slate-200 truncate">{s.title}</div>
                <div className="text-[10.5px] text-slate-500 font-mono">{new Date(s.updated_at).toLocaleString()}{s.escalated ? ` · ${t("as.sent_badge")}` : ""}</div>
              </div>
              <button onClick={(e) => del(e, s.id)} data-testid={`assist-session-delete-${s.id}`} className="opacity-0 group-hover:opacity-100 p-1 text-slate-500 hover:text-[#ff4d6d]"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))}
      </div>
    </div>
  );
};
